import React from 'react';
import { Box, Typography } from '@mui/material';

const ActionBox = ({ icon, label, onClick, disabled = false }) => {
    return (
        <Box
            onClick={!disabled ? onClick : undefined}
            tabIndex={disabled ? -1 : 0}
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                py: 1,
                px: 1.5,
                borderRadius: '10px',
                backgroundColor: disabled ? '#f0f0f0' : 'rgba(167, 30, 59, 0.06)',
                border: '1px solid',
                borderColor: disabled ? '#e0e0e0' : 'rgba(167, 30, 59, 0.15)',
                cursor: disabled ? 'default' : 'pointer',
                opacity: disabled ? 0.5 : 1,
                transition: 'all 0.2s ease',
                '&:hover': disabled ? {} : {
                    backgroundColor: '#a71e3b',
                    borderColor: '#a71e3b',
                    boxShadow: '0 4px 14px rgba(167, 30, 59, 0.3)',
                    transform: 'translateY(-1px)',
                    '& .action-icon': { color: '#fff' },
                    '& .action-label': { color: '#fff' },
                },
            }}
        >
            <Box
                className="action-icon"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: disabled ? '#999' : '#a71e3b',
                    transition: 'color 0.2s ease',
                    '& .MuiSvgIcon-root': { fontSize: '1.1rem' },
                    flexShrink: 0,
                }}
            >
                {icon}
            </Box>
            <Typography
                className="action-label"
                sx={{
                    fontSize: '0.72rem',
                    fontWeight: 600,
                    color: disabled ? '#999' : '#444',
                    lineHeight: 1.2,
                    transition: 'color 0.2s ease',
                    userSelect: 'none',
                }}
            >
                {label}
            </Typography>
        </Box>
    );
};

export default ActionBox;
